import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QrCode, Copy, Check, Share2, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { QRCodeSVG } from 'qrcode.react';
import Navigation from '../components/Navigation';
import { LOGO_SEMENTE } from '../lib/branding';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CompartilharApp = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  
  const shareLink = `https://raizesif.kingdomcloud.com.br/app-pais/cadastro`;

  const copyLink = () => {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = shareLink;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      toast.success('Link copiado!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Não foi possível copiar. Copie manualmente o link acima.');
    }
  };

  const shareWhatsApp = () => {
    const text = encodeURIComponent(`Faca seu cadastro no Projeto Semente e acompanhe o crescimento espiritual do seu filho!\n\n${shareLink}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] pb-24">
      {/* Header */}
      <div className="bg-[#1A4D2E] text-white px-6 py-8">
        <div className="max-w-5xl mx-auto">
          <button onClick={() => navigate(-1)} className="hover:bg-white/10 rounded-full p-2 transition-all mb-2">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-3">
            <QrCode className="w-7 h-7" strokeWidth={2.5} />
            <h1 className="font-nunito font-bold text-3xl">Compartilhar App</h1>
          </div>
          <p className="font-inter text-white/70 text-sm mt-1">Gere o QR Code para novos pais se cadastrarem</p>
        </div>
      </div>

      <div className="max-w-md mx-auto px-4 py-8 space-y-6">
        {/* QR Code Card */}
        <Card className="bg-white rounded-2xl p-8 shadow-xl border border-[#E1ECE5] text-center">
          <div className="bg-white p-4 rounded-2xl inline-block mb-4 shadow-inner border border-gray-100">
            <QRCodeSVG
              value={shareLink}
              size={220}
              level="H"
              fgColor="#1A4D2E"
              imageSettings={{
                src: "/logos/logo_semente.png",
                height: 40,
                width: 40,
                excavate: true
              }}
            />
          </div>
          <h2 className="font-nunito font-bold text-xl text-[#1A4D2E] mb-2">
            Projeto Semente
          </h2>
          <p className="font-inter text-gray-500 text-sm mb-6">
            Escaneie o QR Code para se cadastrar como pai/mae e cadastrar seus filhos
          </p>
          
          {/* Link display */}
          <div className="bg-[#F2F7F4] rounded-xl p-3 flex items-center gap-2 mb-4">
            <p className="font-inter text-sm text-[#1A4D2E] truncate flex-1 text-left" data-testid="share-link">
              {shareLink}
            </p>
            <button
              onClick={copyLink}
              data-testid="btn-copy-link"
              className="flex-shrink-0 bg-[#1A4D2E] text-white rounded-lg p-2 hover:bg-[#145A32] transition-all"
            >
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            </button>
          </div>

          <div className="flex gap-3">
            <Button
              onClick={copyLink}
              data-testid="btn-copy"
              className="flex-1 bg-[#1A4D2E] hover:bg-[#145A32] text-white rounded-full py-5 font-semibold flex items-center justify-center gap-2"
            >
              <Copy className="w-4 h-4" />
              Copiar Link
            </Button>
            <Button
              onClick={shareWhatsApp}
              data-testid="btn-share"
              className="flex-1 bg-[#25D366] hover:bg-[#1fb855] text-white rounded-full py-5 font-bold flex items-center justify-center gap-2"
            >
              <Share2 className="w-4 h-4" />
              WhatsApp
            </Button>
          </div>
        </Card>

        {/* Instructions */}
        <Card className="bg-white rounded-2xl p-6 shadow-lg border border-[#E1ECE5]">
          <h3 className="font-nunito font-bold text-lg text-[#1A4D2E] mb-4">Como funciona?</h3>
          <div className="space-y-4">
            {[
              { num: '1', text: 'Compartilhe o QR Code ou link com os pais' },
              { num: '2', text: 'O pai/mae escaneia e faz o cadastro' },
              { num: '3', text: 'Depois cadastra seus filhos no app' },
              { num: '4', text: 'Pronto! Já pode acompanhar o progresso' }
            ].map(item => (
              <div key={item.num} className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-full bg-[#1A4D2E] text-white flex items-center justify-center font-bold text-sm flex-shrink-0">
                  {item.num}
                </div>
                <p className="font-inter text-gray-700 text-sm pt-1">{item.text}</p>
              </div>
            ))}
          </div>
        </Card>
      </div>

      <Navigation active="inicio" />
    </div>
  );
};

export default CompartilharApp;
